"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _batchStatus = require("./attrs/batchStatus");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var BatchStatusChip = function BatchStatusChip(_ref) {
  var status = _ref.status,
    label = _ref.label;
  var _ref2 = _batchStatus.BATCH_STATUS_MAP.get(status) || {},
    _ref2$icon = _ref2.icon,
    icon = _ref2$icon === void 0 ? null : _ref2$icon,
    _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? '#000000' : _ref2$color;
  return /*#__PURE__*/_react["default"].createElement(_material.Chip, {
    icon: /*#__PURE__*/_react["default"].cloneElement(icon, {
      style: {
        color: color
      }
    }),
    label: label,
    sx: {
      borderColor: color,
      backgroundColor: "".concat(color, "20"),
      color: color,
      borderWidth: 1,
      borderStyle: 'solid',
      borderRadius: '16px',
      padding: '0 8px'
    },
    variant: "outlined"
  });
};
BatchStatusChip.propTypes = {
  status: _propTypes["default"].oneOf(Object.values(_batchStatus.BATCH_STATUS_ENUM)),
  label: _propTypes["default"].string
};
BatchStatusChip.defaultProps = {
  status: null,
  label: ''
};
var _default = exports["default"] = BatchStatusChip;